import { useContext } from "react";
import { StoresFormContext } from "../context/stores-form.context";

const useStoresForm = () => useContext(StoresFormContext);

export default useStoresForm;
